import React, { useState, useEffect, useContext } from 'react';
import { QuantityContext } from '../../QuantitySelector/QuantityProvider';
import { QuoteContext } from '../QuoteProvider';
import { SubmitButton } from '../../leaf-components/SubmitButton';
import { createCartObject } from './helpers';
import { productPropTypes } from '../productPropTypes';
import { resolveService } from '../../../utilities/service-resolver';

const Checkout = ({ product, product2 }) => {
  const {
    installOption, addons, loadState, setLoadingState,
  } = useContext(QuoteContext);
  const { quantities } = useContext(QuantityContext);
  const { url: checkoutUrl } = resolveService('checkout');

  const [cartObject, setCartObject] = useState({});

  const onCheckout = () => {
    setLoadingState(loadState.FINALIZING);
  };

  useEffect(() => {
    if (Array.isArray(installOption?.subs)) {
      const CartObject = createCartObject({
        product, product2, quantities, installOption, addons,
      });
      setCartObject(CartObject);
    }
  }, [product, product2, quantities, installOption, addons]);

  return (
    <form method="POST" action={checkoutUrl} onSubmit={onCheckout}>
      <input type="hidden" name="payload" value={JSON.stringify(cartObject)} />
      <SubmitButton>
        Finalize Appointment
      </SubmitButton>
    </form>
  );
};

Checkout.propTypes = {
  product: productPropTypes,
  product2: productPropTypes,
};

export { Checkout };
